module.exports = __webpack_public_path__ + "static/media/img-print-qr-01.ce565c4b.svg";